import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowLeft, Search, CreditCard } from 'lucide-react';
import { SEO } from '../seo/SEO';

export const PaymentSuccessPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Payment Successful | Banga.ai"
        description="Your payment has been processed successfully. Thank you for your purchase."
      />
      
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8 transition-colors">
        <div className="max-w-md mx-auto">
          <div className="mb-8">
            <Link
              to="/billing"
              className="inline-flex items-center text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Billing
            </Link>
          </div>
          
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8 text-center">
            <div className="py-8">
              <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                Payment Successful!
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Thank you for your purchase. Your subscription is now active and your credits have been added to your account.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link
                  to="/"
                  className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center"
                >
                  <Search className="w-5 h-5 mr-2" />
                  Start Searching
                </Link>
                <Link
                  to="/billing"
                  className="px-6 py-2 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors flex items-center justify-center"
                >
                  <CreditCard className="w-5 h-5 mr-2" />
                  View Subscription
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};